module.exports = __webpack_public_path__ + "img/obras6.55facadb.svg";